import { render } from "./NavSidebarSection.vue?vue&type=template&id=3fc5358c&scoped=true"
import script from "./NavSidebarSection.vue?vue&type=script&lang=js"
export * from "./NavSidebarSection.vue?vue&type=script&lang=js"

import "./NavSidebarSection.vue?vue&type=style&index=0&id=3fc5358c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc5358c"]])

export default __exports__